import axios from '@/utils/api'
import modulo from '@/utils/modulo'

const actions = {
  async getMunicipios () {
    const data = await axios({
      method: 'GET',
      url: 'relatorios/processos/processosByMunicipio'
    })

    return data
  },

  async getOs () {
    const setor = 'CAF'
    const data = await axios({
      method: 'GET',
      url: `relatorios/os/setor/${setor}`
    })

    return data
  },

  async getTiposProcessos ({ commit }) {
    const result = await axios({
      url: modulo.PUBLICO + '/tiposProcessos',
      method: 'GET'
    })

    return result
  },

  async getTecnicosDeCampo () {
    const data = await axios({
      method: 'GET',
      url: 'relatorios/os/perfilTecnico'
    })

    return data
  },

  async getSituacao () {
    const data = await axios({
      method: 'GET',
      url: 'relatorios/os/status'
    })

    return data
  },

  async getVistoriador () {
    const data = await axios({
      method: 'GET',
      url: 'relatorios/os/vistoriador'
    })

    return data
  },

  async getGeomensor () {
    const data = await axios({
      method: 'GET',
      url: 'relatorios/os/geomensor'
    })

    return data
  },

  async getInteressado () {
    const data = await axios({
      method: 'GET',
      url: 'relatorios/os/interessado'
    })

    return data
  },

  async getDadosOs ({ commit }, filtro) {
    const result = await axios({
      method: 'POST',
      url: 'relatorios/os/grafico/findByFilter',
      data: filtro
    })

    return result
  },

  async getDadosProcesso ({ commit }, filtro) {
    const result = await axios({
      method: 'POST',
      url: 'processo/findByFilterOS',
      data: filtro
    })

    return result
  },

  async exportaCSVProcesso ({ commit }, filtro) {
    const file = await axios({
      method: 'POST',
      url: 'processo/os/csv',
      data: filtro,
      responseType: 'blob'
    })

    return file
  },

  async getDetalhesOs ({ commit }, idOS) {
    const result = await axios({
      method: 'GET',
      url: `relatorios/os/detalhes/${idOS}`
    })

    return result
  },

  async exportaCSVOS ({ commit }, filtro) {
    const file = await axios({
      method: 'POST',
      url: 'relatorios/os/csv',
      data: filtro,
      responseType: 'blob'
    })

    return file
  },

  async exportaCSVOSDetalhada ({ commit }, idOS) {
    const file = await axios({
      method: 'GET',
      url: `relatorios/os/detalhes/csv/${idOS}`,
      responseType: 'blob'
    })

    return file
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/relatorios/relatoriosOs.js